import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { baseGrid, SiteWidthBreakpoint } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { headingStyles, paragraphLarge } from '@helpers/typography';
import EventListingCardStyles from '@stories/Components/Cards/EventListingCard/EventListingCard.styles';
import PastEventListingCardStyles from '@stories/Components/Cards/PastEventListingCard/PastEventListingCard.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  overflow: hidden;
  margin-bottom: var(--sectionSpacing);
`;
const TopWrapper = styled.div `
  position: relative;
  padding: ${fluid(32, 48)} 0 ${fluid(48, 64)};

  &::before,
  &::after {
    content: '';
    height: 100%;
    position: absolute;
    z-index: 1;
    top: 0;
  }

  &::before {
    left: 50%;
    transform: translateX(-50%);
    width: 100vw;
    background-color: ${brand.primary.blueGrey};
  }

  &::after {
    --width: ${fluid(146, 232)};

    right: calc(var(--sitePadding) * -1);
    width: var(--width);
    background-color: ${brand.secondary.blueGrey};
    border-radius: 5000px 0 0 5000px;

    @media ${from(SiteWidthBreakpoint)} {
      right: calc((100vw - (var(--siteWidth) - (var(--sitePadding) * 2))) * -0.5);
    }
  }
`;
const Title = styled.h2 `
  ${headingStyles};

  font-size: ${fluid(22, 26)};
  line-height: ${fluid(32, 36)};
  text-align: center;
  position: relative;
  z-index: 2;
  margin: 0 0 24px;
`;
const ResultsContainer = styled.div `
  ${baseGrid};

  row-gap: ${fluid(24, 80)};
  scroll-margin: var(--scrollOffset, 0px) 0 0;

  ${PastEventListingCardStyles.Container},
  ${EventListingCardStyles.Container} {
    grid-column: span 24;
  }

  ${PastEventListingCardStyles.Container} {
    @media ${from(Device.Tablet)} {
      grid-column: span 12;
    }

    @media ${from(Device.TabletLarge)} {
      grid-column: span 8;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: span 6;
    }
  }
`;
const NoResultsText = styled.p `
  ${paragraphLarge};

  grid-column: span 24;
  text-align: center;
  margin-top: ${fluid(16, 24)};
`;
const PagingSummary = styled.div `
  ${fonts.apparat.medium};

  font-size: ${fluid(18, 20)};
  line-height: ${fluid(28, 30)};
  text-align: center;

  > span {
    ${fonts.apparat.semiBold};
  }

  &[data-position='top'] {
    margin: 0 0 ${fluid(32, 48)};
  }

  &[data-position='bottom'] {
    margin: ${fluid(30, 64)} 0 0;
  }
`;
const EventListingStyles = {
    Container,
    NoResultsText,
    ResultsContainer,
    Title,
    PagingSummary,
    TopWrapper,
};
export default EventListingStyles;
